/**
 * Created by Administrator on 2017/8/25.
 */
import './index.less'

export default function () {
  return true
}



// WEBPACK FOOTER //
// ./src/components/spinner/index.js